export enum Spacing {
  NONE = '0px',
  EXTRA_SMALL = '6px',
  SMALL = '12px',
  REGULAR = '16px',
  MEDIUM = '20px',
  LARGE = '32px',
  EXTRA_LARGE = '48px',
}
